module.exports = __webpack_public_path__ + "static/project-2-4-a246cb34ba87fd427b62c5d46145772a.jpg";